import React, { useState } from 'react';
import Sidebar from '@/components/layout/Sidebar';
import Header from '@/components/layout/Header';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  // State to manage sidebar collapse, lifted from Sidebar.jsx
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Function to toggle sidebar collapse state
  const toggleSidebarCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar isCollapsed={isCollapsed} toggleSidebarCollapse={toggleSidebarCollapse} />
      <div className={`flex flex-col flex-1 transition-all duration-200 ease-in-out
        ${isCollapsed ? 'md:ml-[100px]' : 'md:ml-[256px]'}`}> {/* Dynamic margin for content based on sidebar state */}
        <Header isSidebarCollapsed={isCollapsed} /> {/* Pass sidebar collapsed state to Header */}
        {/* Added overflow-x-hidden to prevent horizontal overflow on pages */}
        <main className="flex-1 p-6 pt-16 overflow-y-auto overflow-x-hidden"> {/* Added pt-16 to account for fixed header height */}
          <div className="mx-auto max-w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
